"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useToastContext = exports.ToastProvider = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const toast_1 = require("primereact/toast");
const ToastContext = (0, react_1.createContext)(null);
const ToastProvider = ({ children, }) => {
    const toastRef = (0, react_1.useRef)(null);
    const isMobile = window.innerWidth < 768;
    return ((0, jsx_runtime_1.jsxs)(ToastContext.Provider, { value: { toastRef }, children: [children, (0, jsx_runtime_1.jsx)(toast_1.Toast, { className: isMobile ? 'w-3/4 text-xs' : 'w-full', ref: toastRef })] }));
};
exports.ToastProvider = ToastProvider;
const useToastContext = () => {
    const context = (0, react_1.useContext)(ToastContext);
    if (!context) {
        throw new Error('useToastContext debe usarse dentro de un ToastProvider');
    }
    return context;
};
exports.useToastContext = useToastContext;
